import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { cn } from "@/lib/utils";
import { CogIcon } from "../HomeIcons";
import { GLASS_BLOCK_CLASS, type GlassTheme } from "../glass";

/** Bloc « Configurer le tableau de bord » : ouvre le choix du fond. */
export const ConfigureBlock = ({
  theme,
  onOpen,
}: {
  theme: GlassTheme;
  onOpen: () => void;
}) => {
  const vt = useVisibleT();
  return (
    <button
      type="button"
      onClick={onOpen}
      className={cn(
        GLASS_BLOCK_CLASS,
        "flex w-full items-center gap-2.5 p-4 text-left text-sm font-medium transition-opacity hover:opacity-90",
      )}
      style={theme.surface}
    >
      <CogIcon className="shrink-0" />
      {vt("bo.home.configure.open", "Configurer le tableau de bord")}
    </button>
  );
};
